import {
  ContentResourceType,
  type ShowcaseContentItemDto,
} from '@repo/api/web/models'
import type { Ref } from 'vue'

/**
 * Приложенные файлы материала (CMS MR 12): бэкенд уже отдаёт только видимые
 * в текущем канале и в нужном порядке — здесь лишь разделение на галерею
 * и документы для соответствующих секций страницы
 */
export function useContentMedia(
  item: Ref<ShowcaseContentItemDto | null | undefined>,
) {
  const resources = computed(() => item.value?.resources ?? [])

  const images = computed(() =>
    resources.value.filter(file => file.type === ContentResourceType.IMAGE),
  )

  const documents = computed(() =>
    resources.value.filter(file => file.type === ContentResourceType.DOCUMENT),
  )

  return { images, documents }
}
